<template>
	<div>
		<div class="content">
			<div class="panel panel-register">
				<div class="container box">
					<div class="register">
						<div class="register-primary">
							<div class="form-group mb0">
								<label class="control-label">&nbsp;</label>
								<div class="help-block">
									<h2 class="text-dark">
										欢迎注册
										<span>
											已有账号？
											<router-link class="text-blue" :to="{path:'/login'}">
												请登录
											</router-link>
										</span>
									</h2>
								</div>
							</div>
							<div class="form-group mt20">
								<label class="control-label">设置密码：</label>
								<input placeholder="密码最少5位" v-model="pass" class="form-control" @focus="visiblePass=false" :class="{'form-control-error':visiblePass}" />
								<div class="help-block">
									<span class="onshow">
										<i class="icon-tishi iconfont"></i>
										建议使用字母、数字和符号两种及以上的组合，5位以上
									</span>
								</div>
							</div>
							<div class="form-group ">
								<label class="control-label">确认密码：</label>
								<input placeholder="请再次输入密码" v-model="passY" class="form-control"  @focus="visiblePassY=false" :class="{'form-control-error':visiblePassY}" />
								<div class="help-block">
									<span class="onshow">
										<i class="icon-tishi iconfont"></i>
										请再次输入登录密码，保证无误
									</span>
								</div>
							</div>
							<div class="form-group">
								<label class="control-label">手机号码：</label>
								<input placeholder="请输入手机号" v-model="phone" class="form-control" @focus="visiblePhone=false" :class="{'form-control-error':visiblePhone}" />
								<div class="help-block">
									<span class="onshow">
										<i class="icon-tishi iconfont"></i>
										注册成功可用于登录，修改密码等
									</span>
								</div>
							</div>
							<div class="form-group">
								<label class="control-label">短信验证码：</label>
								<input placeholder="请输入手机验证码" @focus="visibleCode=false" v-model="code" class="form-control form-control-short" :class="{'form-control-error':visibleCode}" />
								<a class="btn btn-green" href="javascript:;" @click="getCode()" :class="{'form-control-error disabled':time!=0}">
									{{time === 0?'获取验证码':time+'秒后可重新获取'}}
								</a>
								<div class="help-block">
									<span class="onshow">
										<i class="icon-tishi iconfont"></i>
										请输入收到的手机短信验证码
									</span>
								</div>
							</div>
							<div class="form-group ">
								<label class="control-label">邀请码：</label>
								<input placeholder="请输入邀请码" v-model="yq" class="form-control" />
								<div class="help-block">
									<span class="onshow">
										<i class="icon-tishi iconfont"></i>
										选填！如果你是亲朋好友邀请来{{$namePc}}可以填写他的用户ID作为邀请码
									</span>
								</div>
							</div>
							<div class="form-group">
								<label class="control-label">&nbsp;</label>
								<label class="checkbox pull-left">
									<input type="checkbox" :checked="checkedDeal" />
									<span class="checkbox-text">
										已阅读并同意「
										<router-link class="text-blue" :to="{path:'/terrace'}">服务协议</router-link>
										」和「
										<router-link class="text-blue" :to="{path:'/terraceUser'}">隐私政策</router-link>
										」
									</span>
								</label>
							</div>
							<div class="form-group">
								<label class="control-label">&nbsp;</label>
								<button class="btn btn-primary btn-block btn-md" type="submit" @click="getRegister">同意协议并登录</button>
							</div>
<!-- 							<div class="form-group">
								<label class="control-label">&nbsp;</label>
								<div class="login-other">
									<fieldset class="orline">
										<legend class="orline-title">使用其他登录方式</legend>
									</fieldset>
									<a class="login-other-wechat" @click="$fxLink.checkWxLogin">
										<i class="iconfont icon-weixin1"></i>
										微信帐号授权登录
									</a>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				checkedDeal:true,
				time:0,
				interval:null,
				visiblePass:false,
				visiblePassY:false,
				visiblePhone:false,
				visibleCode:false,
				pass:"",
				passY:"",
				phone:"",
				code:"",
				yq:""
			}
		},
		created(){

		},
		methods:{
			getCode(){
				if(this.$fxLink.checkPhone(this.phone)){
					this.visiblePhone = true
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					return
				}
				this.$api.sendMessageRegister({
					mobile:this.phone
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'warning'
						});
						this.time = 60 ;
						this.interval = setInterval(() => {
							if(this.time == 0){
								clearInterval(this.interval)
								return
							}
							this.time --
						},1000)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
						return
					}
				})
			},
			getRegister(){
				if(!this.pass){
					this.visiblePass = true
					this.$message({
						message: '密码不能为空',
						type: 'warning'
					});
					return
				}
				if(this.pass.length < 5){
					this.visiblePass = true
					this.$message({
						message: '密码不能少于5位',
						type: 'warning'
					});
					return
				}
				if(!this.passY){
					this.visiblePassY = true
					this.$message({
						message: '请再次输入密码',
						type: 'warning'
					});
					return
				}
				if(this.pass != this.passY){
					this.visiblePass = true
					this.visiblePassY = true
					this.$message({
						message: '两次密码不一致',
						type: 'warning'
					});
					return
				}
				if(this.$fxLink.checkPhone(this.phone)){
					this.visiblePhone = true
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					return
				}
				if(!this.code){
					this.visiblePhone = true
					this.$message({
						message: '验证码不能为空',
						type: 'warning'
					});
					return
				}
				if(!this.checkedDeal){
					this.$message({
						message: '请先同意协议',
						type: 'warning'
					});
					return
				}
				this.$api.register({
					phone: this.phone,
					code: this.code,
					password: this.pass,
					password2: this.passY,
					yq:this.yq
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: '注册成功',
							type: 'success'
						});
						this.$router.push({ path:'/login'})
						// window.location.reload();
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			}
		}
	}
</script>

<style>
	.panel-register {
			padding: 50px 0;
			background-color: #f9fafe!important;
	}
	.signform .absolute-right {
		line-height: 50px;
		padding: 0 15px 0 0;
		font-size: 14px;
	}
	.signform .control-label {
		position: absolute;
		top: 0;
		left: 0;
		line-height: 52px;
		padding: 0;
	}
  .loginstdz{
  	margin-top: 5px;

  }
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue